import { compose } from 'ramda';

import { saveReturnPath } from '#src/store/location/actions';

import { anonymousOnly } from '../guards';

export const path = '/glp-won/:gameId/claim-spot';
export const component = 'ClaimSpot';

export const thunk = () => (dispatch, getState) => {
  if (anonymousOnly(dispatch, getState)) return;
  compose(dispatch, saveReturnPath)();
};
